import companyAdmin from './company-admin'
import companyMacrotrend from './company-macrotrend'
import companyMegatrend from './company-megatrend'
import companyMicrotrend from './company-microtrend'
import dashboard from './dashboard'
import error from './error'
import evaluation from './evaluation'
import innovationField from './innovation-field'
import innovationProject from './innovation-project'
import insights from './insights'
import login from './login'
import password from './password'
import profile from './profile'
import searchAgent from './search-agent'
import trial from './trial'
import trendfinder from './trendfinder'
import trendradar from './trendradar'
import workspace from './workspace'
import missingFeature from './missing-feature'

export default {
    companyAdmin,
    companyMacrotrend,
    companyMegatrend,
    companyMicrotrend,
    dashboard,
    error,
    evaluation,
    innovationField,
    innovationProject,
    insights,
    login,
    password,
    profile,
    searchAgent,
    trial,
    trendfinder,
    trendradar,
    workspace,
    missingFeature
}
